<template>
  <div class="group-hover:scale-110 transition-transform">
    <CheckBadgeIcon v-if="row.isSuccess" class="size-4 text-green-800" />
    <NoSymbolIcon v-else class="size-4 text-red-800" />
  </div>
</template>

<script setup>
import { CheckBadgeIcon, NoSymbolIcon } from '@heroicons/vue/24/outline';

defineProps({
  row: {
    type: Object,
    default: () => {}
  }
});
</script>
